import script from "./MTA.vue?vue&type=script&lang=js"
export * from "./MTA.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__